import { render, staticRenderFns } from "./LaboratoryCard.vue?vue&type=template&id=2629dec5"
import script from "./LaboratoryCard.vue?vue&type=script&lang=js"
export * from "./LaboratoryCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports